import React, { useEffect } from 'react';
import './psejemplo.css';
import { psejemplo } from '../../json/psejemplo';


const Psejemplo = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className='container container-mh'>
      <div className='row'>
        <div className='col-12'>
          <h3 className='title'>Nómbre del Programa Social</h3>
          <hr className='hr-gob' />
        </div>
      </div>
      
      <div className='row'>
        <div className='col-12 container-armon'>
          <div className='armo-collapse'>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <img src='./assets/imgs/Psejemplo.png' width='80%' align='center' alt='Imagen' />
              <div style={{ textAlign: 'left' }}>
                <h6 className='description' style={{ marginTop: '20px' }}>
                  Descripción e información reelevante del programa social, Descripción e información reelevante del programa social, Descripción e información reelevante del programa social, <br /><br />
                  Descripción e información reelevante del programa social, Descripción e información reelevante del programa social, Descripción e información reelevante del programa social, 
                  Descripción e información reelevante del programa social, Descripción e información reelevante del programa social, Descripción e información reelevante del programa social, 
                </h6><br />
                <h5 style={{ fontWeight: 'bold' }}>Beneficiarios</h5>
                <p>
                  Descripción de los beneficiarios a los que esta dirigido el Programa Social, Descripción de los beneficiarios a los que esta dirigido el Programa Social,
                  Descripción de los beneficiarios a los que esta dirigido el Programa Social, Descripción de los beneficiarios a los que esta dirigido el Programa Social,
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Beneficio</h5>
                <p>
                  Descripción del beneficio que obtendrán los beneficiarios, Descripción del beneficio que obtendrán los beneficiarios, Descripción del beneficio que obtendrán los beneficiarios,
                  Descripción del beneficio que obtendrán los beneficiarios, Descripción del beneficio que obtendrán los beneficiarios, Descripción del beneficio que obtendrán los beneficiarios.
                </p>
                <h5 style={{ fontWeight: 'bold' }}>Requisitos</h5>
                <p>
                  Para las personas que cumplan con los criterios establecidos:<br />
                  <ul>
                  <li>Requisito o documento requerido.<br />                    
                  </li>
                  <li>Requisito o documento requerido.<br />
                  </li>
                  <li>Requisito o documento requerido.<br />
                  </li>
                  <li>Requisito o documento requerido.<br />
                  </li>
                  <li>Requisito o documento requerido.<br />
                  </li>
                  <li>Requisito o documento requerido.<br />
                  </li>
                  <li>Requisito o documento requerido.<br />
                  </li>
                  </ul></p>
                <h5 style={{ fontWeight: 'bold' }}>¿Cómo solicitar el apoyo?</h5>
                <p>
                  Para ser beneficiario de este apoyo es necesario llenar el formato que se otorgará en el lugar indicado o iniciar el registro en línea <a
                href='https://www.google.com'
                target='_blank'
                rel="noopener noreferrer"
                style={{ fontWeight: 'bold' }}
                className='span'
                >
                   aquí
                </a>.<br /><br />
                  Se realizarán visitas a los domicilios para hacer el censo correspondiente.<br />
                  Sólo se otorgará un apoyo por familia.<br />
                  Para más información consulta las Reglas de operación del programa <a
                  href='https://www.google.com'
                  target='_blank'
                  rel="noopener noreferrer"
                  style={{ fontWeight: 'bold' }}
                  className='span'
                >
                    aquí
                </a>.<br />
                </p>
                <h5 style={{ fontWeight: 'bold' }}><strong>Fechas Importantes</strong></h5>
                <p>
                <ul>
                  <li>Periodo de Recepción de Solicitudes<br />                    
                  </li>
                  <li>Fecha de Publicación de resultados<br />
                  </li>
                </ul>
                    <a
                // href='https://www.google.com'
                // target='_blank'
                // rel="noopener noreferrer"
                // style={{ fontWeight: 'bold' }}
                // className='span'
                >
                
                </a>.
                </p>
              </div>
            </div>
            
          </div>
        </div>
      </div>    
    </div>
  );
};

export default Psejemplo;